import { CardSvg } from '@/play/cardSvg'

/** Home card art: glass boxes on shelves, one with a hole and metal and goo running out into a pool below. */
export function OozeCardArt() {
  return (
    <CardSvg bg="#eef0f3">
      <rect y="168" width="320" height="32" fill="#e9e4da" />
      {/* shelves */}
      <rect x="20" y="78" width="120" height="8" rx="2" fill="#b98c62" />
      <rect x="170" y="110" width="130" height="8" rx="2" fill="#b98c62" />
      {/* left box: silver metal, a hole low on its right side */}
      <rect x="40" y="34" width="56" height="44" rx="3" fill="#dff3ff" opacity="0.6" stroke="#9fc4dc" strokeWidth="2" />
      <rect x="44" y="50" width="48" height="26" rx="2" fill="#c9d1da" />
      <path d="M96 66 C 104 66, 108 70, 110 78 C 114 100, 116 140, 118 168" fill="none" stroke="#c9d1da" strokeWidth="7" strokeLinecap="round" />
      {/* right box: metal under pink goo */}
      <rect x="200" y="62" width="60" height="48" rx="3" fill="#dff3ff" opacity="0.6" stroke="#9fc4dc" strokeWidth="2" />
      <rect x="204" y="94" width="52" height="14" rx="2" fill="#c9d1da" />
      <rect x="204" y="74" width="52" height="20" rx="2" fill="#ff5fa2" />
      <path d="M200 84 C 190 86, 186 96, 184 110 M178 118 C 176 140, 172 156, 170 168" fill="none" stroke="#ff5fa2" strokeWidth="7" strokeLinecap="round" />
      {/* the pool below: metal at the bottom, goo over it */}
      <ellipse cx="146" cy="172" rx="54" ry="7" fill="#c9d1da" />
      <ellipse cx="160" cy="167" rx="30" ry="6" fill="#ff5fa2" />
      <path d="M128 168 C 136 165, 146 165, 152 167" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
    </CardSvg>
  )
}
